import { render, staticRenderFns } from "./sixSelect.vue?vue&type=template&id=edc0a23c&scoped=true&"
import script from "./sixSelect.vue?vue&type=script&lang=js&"
export * from "./sixSelect.vue?vue&type=script&lang=js&"
import style0 from "./sixSelect.vue?vue&type=style&index=0&id=edc0a23c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc0a23c",
  null
  
)

export default component.exports